import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Paper,
  Box,
  IconButton,
  Typography,
  Grid,
  Divider
} from "@mui/material";

import { useReactToPrint } from "react-to-print";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";

const Bonafide2 = () => {
  const navigate = useNavigate();
  const componentRef = useRef();

  const { oId } = useAuth();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const location = useLocation();
  const studentData = location.state?.studentData;
  console.log("student:",studentData);

  const [originalData, setOriginalData] = useState({});
  const [loading, setLoading] = useState(true);
    
  const [companyInfo, setCompanyInfo] = useState({
              schoolName: "",
              pincode: "",
              primaryContact: "",
              secondaryContact: "",
              boardAffiliation: "",
              schoolAddress: "",
              affiliationNumber: "",
              city: "",
              state: "",
              schoolEmailId: "",
              schoolLogo: "",
              schoolStamp: "",
            });
  const [tempInfo, setTempInfo] = useState({ ...companyInfo });
  const [orgloading, setOrgLoading] = useState(true); 
      
  console.log("originaldata:",originalData);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

    //organization details api 
            useEffect(() => {
              const fetchCompanyInfo = async () => {
                try {
                  const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  
          
                  const data = await response.json();
                  setCompanyInfo({
                    schoolLogo: data.schoolLogo,
                    schoolStamp:data.schoolStamp,
                    schoolName: data.schoolName,
                    city: data.city,
                    state: data.state,
                    affiliationNumber: data.affiliationNumber,
                    schoolAddress: data.schoolAddress,
                    primaryContact: data.primaryContact,
                    boardAffiliation: data.boardAffiliation,
                    secondaryContact: data.secondaryContact,
                    pincode: data.pincode,
                    schoolEmailId: data.schoolEmailId,
                  });
                  setTempInfo(data);
          
                  setOrgLoading(false); // Data fetched, stop loading
          
                } catch (error) {
                  console.error("Error fetching company info:", error);
                  setOrgLoading(false); // Stop loading even if there's an error
                }
              };
          
              fetchCompanyInfo();
            }, []);

  return (
    <Card
      sx={{
        borderRadius: "16px",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#f4f6f9",
        margin: "60px 1% 1%",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Back Button */}
      <Box className="print-hide" sx={{ position: "absolute", top: 20, left: 20, display: "flex", alignItems: "center", gap: "10px" }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
          <KeyboardBackspaceIcon fontSize="medium" />
        </IconButton>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Bonafide Certificate
        </Typography>
      </Box>

      {/* Print Button */}
      <Box className="print-hide" sx={{ position: "absolute", top: 20, right: 20 }}>
        <button
          onClick={handlePrint}
          style={{
            padding: "8px 16px",
            borderRadius: "8px",
            color: "#fff",
            cursor: "pointer",
            background: "linear-gradient(90deg, #3C3972, #3C3972)",
            border: "none",
            fontWeight: "bold",
            fontSize: "14px",
            boxShadow: "0 5px 10px rgba(30, 144, 255, 0.3)",
          }}
        >
          Print
        </button>
      </Box>

      {/* Printable Certificate */}
      <Paper
        ref={componentRef}
        elevation={3}
        sx={{
          mt: 6,
          p: 5,
          width: "210mm",
         
          border: "1.5px solid black",
          backgroundColor: "#fff",
          '@media print': {
            boxShadow: "none",
            border: "1.5px solid black",
            marginTop: "10mm",
            padding: "30px",
          },
        }}
      >
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {companyInfo.schoolName}
          </Typography>
          <Typography variant="body2">
            {companyInfo.schoolAddress} - {companyInfo.pincode}
          </Typography>
          <Typography variant="body2">
            Phone: {companyInfo.primaryContact} | Email: {companyInfo.schoolEmailId}
          </Typography>
          <Divider sx={{ my: 2 }} />
        </Box>

        <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between" }}>
  <Typography variant="body1" fontStyle="italic">
    Admission No: {studentData?.admissionNumber}
  </Typography>
  <Typography variant="body1" fontStyle="italic">
    Date: {new Date().toLocaleDateString()}
  </Typography>
</Box>


        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            fontFamily: "Georgia, serif",
            mb: 4
          }}
        >
          BONAFIDE CERTIFICATE
        </Typography>

        <Typography
          variant="body1"
          align="justify"
          sx={{ fontSize: "1.1rem", lineHeight: "1.8", mb: 2 }}
        >
          This is to certify that Mr./Ms. <strong>{`${studentData?.firstName?.toUpperCase()} ${studentData?.lastName?.toUpperCase()}`}</strong>, S/O or D/O of
          Mr./Ms. <strong>{`${studentData?.fathersFirstName?.toUpperCase()} ${studentData?.fathersLastName?.toUpperCase()}`}</strong>, bearing Roll Number <strong>____________</strong>, is a
          student of <strong>{`${studentData?.romanNumberClass} - ${studentData?.sections} `}</strong> (Course/Grade) for the
          academic year <strong>{`${studentData?.studentJoinedYear}`}</strong>. His / Her character is was found
          <strong> Satisfactory</strong>.
        </Typography>

        <Typography
          variant="body1"
          align="justify"
          sx={{ fontSize: "1.1rem", lineHeight: "1.8", mb: 6 }}
        >
          He/She is reliable, sincere, hardworking, and bears a good moral
          character.
        </Typography>

        <Grid container>
  <Grid item xs={12}>
    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 6 }}>
      <Box sx={{ textAlign: "right" }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          ________________
        </Typography>
        <Typography variant="body2" fontStyle="italic">
          Signature of Principal
        </Typography>
      </Box>
    </Box>
  </Grid>
</Grid>

      </Paper>
    </Card>
  );
};

export default Bonafide2;